import { render, staticRenderFns } from "./buy-sell-chart.vue?vue&type=template&id=4d2548d4"
import script from "./buy-sell-chart.vue?vue&type=script&lang=js"
export * from "./buy-sell-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports